export const assetCache = new Map();
export const pendingAssets = new Map();
